import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { ICVHistoricoBusqueda, IFiltrosHistorico } from 'src/model/candidato-api'
import { BaseFeaturesComponent } from '../_base/base-features.component'

class PanelBusquedaHistoricComponentCtrl extends BaseFeaturesComponent {
  filtroHist = {
    value: null as string | null,
  }

  listado = {
    valido: false,
    list: [] as ICVHistoricoBusqueda[],
  }

  panelcv = {
    $visible: false,
    cv: null as ICVHistoricoBusqueda,
  }
  datosTipos: TiposDocEstadosStore

  constructor(
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  $onInit(): void {
    this.$log.info('[PanelBusquedaHistoricComponentCtrl] onInit')

    this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(
      (tiposResponse) => (this.datosTipos = new TiposDocEstadosStore(tiposResponse))
    )
  }

  aplicaFiltrosHist() {
    var _f: IFiltrosHistorico = {
      estado: null,
      limit: -1,
      idcvhist: null,
      q_value: this.filtroHist.value,
      usuarioGestor: null,
    }

    this._callbackHistorico(_f) //
      .then((listadoRes) => {
        this.listado.list = listadoRes.cvList
        this.listado.valido = true
      })
  }

  private _callbackHistorico(_f: IFiltrosHistorico) {
    if (this.esAdmin()) {
      return this.AccesoDatos.HistoricCurr_CLIENT.listCV(_f)
    } else return this.AccesoDatos.HistoricSolicitudes_CLIENT.listCV(_f)
  }

  accesscvhist(idx: number) {
    this.$log.debug('access', this.listado.list[idx])
    this.panelcv.cv = this.listado.list[idx]
    this.panelcv.$visible = true
  }
}

angular.module('candidato').component('panelBusquedaHistoric', {
  bindings: {},
  controller: PanelBusquedaHistoricComponentCtrl,
  // templateUrl: "panel-busqueda-historic.component.html",
  template: require('./panel-busqueda-historic.component.html'),
})
